// extracted by mini-css-extract-plugin
export default {"menuBlock":"KF-z","title":"LF-z","nav":"MF-z","flexCell":"NF-z","facetLink":"OF-z"};